import React from 'react'
import PropTypes from 'prop-types'

const Panel = ({tabs, currentTab, changeTab}) => {
  const activeClass = (tabName) => {
    return currentTab == tabName ? 'active' : ''
  } 

  const onChangeTab = (e, value) => {
    e.preventDefault()
    changeTab(value)
  }

  return <div className='edit-form-panel'>
    { tabs.map((t,i) => {
        return <button className={activeClass(t)} key={i} onClick={(e) => onChangeTab(e, t)}>{t}</button>
      })
    }
  </div>
}

Panel.propTypes = {
  tabs: PropTypes.array.isRequired,
  currentTab: PropTypes.string.isRequired,
  changeTab: PropTypes.func.isRequired,
}

export default Panel
